import { getStorageName } from './storage'

export const MAIN_DB_NAME = 'App.WebPlays'
export const MAIN_DB_NAME_VERSION = 2
export const ACTION_CARDS_STORE_NAME = `actionCards`
export const ACTION_CARDS_STORE_INDEX_BY_PLAYBOOKS = `byPlaybookId`

export const QUESTION_FILE_UPLOAD_STORE_NAME = `questionsFileUploadData`

export const FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME = `funnelViewOpenedSeparators`

let webPlaysDb
export async function getWebPlaysDbLazy() {
  if (!webPlaysDb) {
    webPlaysDb = await getWebPlaysDb()
  }
  return webPlaysDb
}

export async function getWebPlaysDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(MAIN_DB_NAME, MAIN_DB_NAME_VERSION)

    request.onupgradeneeded = function () {
      const db = this.result

      // Create an object store for action cards
      if (!db.objectStoreNames.contains(ACTION_CARDS_STORE_NAME)) {
        const store = db.createObjectStore(ACTION_CARDS_STORE_NAME, { keyPath: 'key' })
        store.createIndex(ACTION_CARDS_STORE_INDEX_BY_PLAYBOOKS, 'playbookId', { unique: false })
      }

      // Create an object store for funnel view opened separators
      if (!db.objectStoreNames.contains(FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME)) {
        db.createObjectStore(FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME, { keyPath: 'playbookId' })
      }
    }

    request.onsuccess = function () {
      resolve(this.result)
    }

    request.onerror = function () {
      reject(this.error)
    }
  })
}

export async function getFileQuestionsDb(playbookId) {
  return new Promise((resolve, reject) => {
    const dbName = getStorageName(playbookId)
    const request = indexedDB.open(dbName)

    request.onupgradeneeded = function () {
      const db = request.result
      // Create an object store with "id" as the key
      if (!db.objectStoreNames.contains(QUESTION_FILE_UPLOAD_STORE_NAME)) {
        db.createObjectStore(QUESTION_FILE_UPLOAD_STORE_NAME, { keyPath: 'id', autoIncrement: true }) // "id" is the primary key
      }
    }

    request.onsuccess = function () {
      resolve(request.result)
    }

    request.onerror = function () {
      reject(request.error)
    }
  })
}

export async function deleteFileQuestionsDb(playbookId) {
  const dbName = getStorageName(playbookId)
  await deleteDb(dbName)
}

async function deleteDb(dbName) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase(dbName)

    request.onsuccess = function () {
      resolve()
    }

    request.onerror = function () {
      reject(request.error)
    }

    request.onblocked = function () {
      reject()
    }
  })
}
